import {Button, Select, Tooltip} from 'antd';
import React, {useEffect, useState} from 'react';

import {Campaign, User} from '../../../../types/src';
import {getEllipsedText, isCampaignRetention} from '../../utils';

interface SelectCampaignProps {
  user: User;
  campaigns: Campaign[];
  conversation: any;
  addReceiverToManualSequence: any;
  removeReceiverFromManualSequence: any;
  getCampaignByReceiverFromManualSequence: any;
  manualSequenceCampaign: any;
  manualSequenceLoading: boolean;
}

const {Option} = Select;

export const SelectCampaign = ({
  user,
  campaigns,
  conversation,
  addReceiverToManualSequence,
  removeReceiverFromManualSequence,
  getCampaignByReceiverFromManualSequence,
  manualSequenceLoading,
  manualSequenceCampaign,
}: SelectCampaignProps) => {
  const [campaignId, setCampaignId] = useState(undefined);

  useEffect(() => {
    if (user && conversation) {
      getCampaignByReceiverFromManualSequence(conversation.receiver.id, user.id);
    }
  }, [conversation?.receiver?.id, user?.id, getCampaignByReceiverFromManualSequence]);

  useEffect(() => {
    setCampaignId(manualSequenceCampaign?.id);
  }, [manualSequenceCampaign]);

  if (!user || (!user && !conversation)) return null;

  const onSave = () => {
    addReceiverToManualSequence(campaignId, conversation.receiver.id, user.id);
  };

  const onRemove = () => {
    removeReceiverFromManualSequence(campaignId, conversation.receiver.id, user.id);
  };

  const retentions =
    campaigns.filter(
      (campaign: Campaign) =>
        isCampaignRetention(campaign) && campaign.selectedUser && campaign.selectedUser.id === user.id
    ) || [];
  const isSaved = manualSequenceCampaign && manualSequenceCampaign.id;
  const isInvalidConversation = conversation && conversation.ur_invalid === 6;

  return (
    !isInvalidConversation && (
      <div style={{display: 'flex', padding: '10px'}}>
        <Select
          loading={manualSequenceLoading}
          onChange={(campaignId: number) => {
            setCampaignId(campaignId);
          }}
          disabled={Boolean(!!isSaved || user.archived)}
          placeholder="Add to nurturing campaign"
          value={campaignId}
          style={{maxWidth: '180px', marginRight: '10px'}}
        >
          {retentions.map(r => {
            const hasEllipsis = r.name.length > 25;
            return (
              <Option key={r.id} value={r.id}>
                <Tooltip title={r.name}>{hasEllipsis ? getEllipsedText(r.name, 25) : r.name}</Tooltip>
              </Option>
            );
          })}
        </Select>
        <div>
          {isSaved ? (
            <Button disabled={Boolean(user.archived)} type="primary" onClick={onRemove}>
              Clear
            </Button>
          ) : (
            <Button disabled={Boolean(user.archived)} type="primary" onClick={onSave}>
              Save
            </Button>
          )}
        </div>
      </div>
    )
  );
};
